var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"id":_vm.id,"readonly":_vm.readonly,"autocomplete":_vm.autocomplete},on:{"focus":_vm.selectAll,"input":function($event){return _vm.$emit('input', $event.target.value)},"blur":function($event){return _vm.$emit('blur')}}})}
var staticRenderFns = []

export { render, staticRenderFns }